'use client';

import { useTranslations } from 'next-intl';

const email = 'contact@out-app.com';

export default function ContactOurTeam() {
  const t = useTranslations('Pages.Event.EventPagePlaceSection');

  return (
    <button
      onClick={() => window.open(`mailto:${email}`)}
      className='flex w-full items-center space-x-2'
    >
      <div className=''>
        <p className='text-left'>
          {t('contactOutTeam')} <span className='font-bold italic'>OUT.</span>
        </p>
        <p className='text-left font-bold text-primary-filled-default underline'>
          {t('clickHere')}
        </p>
      </div>
    </button>
  );
}
